import { useMutation } from '@tanstack/react-query';
import BillingService from '../services/BillingService';
import Notification from '../../App/components/Notification';
import { downloadBlob, parseArrayBufferError } from '../utils/downloadBlob';
var XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export function useExportBillingReport() {
    return useMutation({
        mutationFn: function (id) {
            return BillingService.exportDetailedBillingReport(id, { responseType: 'arraybuffer' });
        },
        onSuccess: function (res) {
            downloadBlob(res.data, 'faturas-mensal.xlsx', XLSX_MIME_TYPE);
        },
        onError: function (err) {
            var _a, _b;
            var data = parseArrayBufferError((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data);
            if (((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                Notification().Notify.failure('Usuário não tem permissão para executar essa ação!');
            }
            else {
                Notification().Notify.failure(data.error || 'Erro ao exportar relatório');
            }
        },
    });
}
